export enum EventTypes {
  AllEvents = "allEvents",
  DsuEvents = "dsuEvents",
  PartnerEvents = "partnerEvents",
}

export enum UsageType {
  default,
  girdle,
}
export interface CheckProps {
  allEvents?: boolean;
  dsuEvents?: boolean;
  partnerEvents?: boolean;
  type?: UsageType;
}
